import { HttpErrorMessageCode } from './errors.models';

export const HttpErrorMessages: Record<HttpErrorMessageCode, string> = {
  PurchaseError:
    'There was an error purchasing your policy. Please check your details and try again.',
  Declined:
    'Your card payment was declined. Please check your details or try again with a different card.',
  CardExpired: 'Your card has expired. Please try again with a different card.',
  InsufficientFunds:
    'Your card payment was declined due to insufficient funds. Please check with your bank or try again with a different card.',
  InvalidInputFallback:
    'Error encountered. Please check your input and try again.',
  ServerError:
    'Unfortunately, we’ve encountered a problem while processing your request. Please try again or refresh your browser.',
  NoInternet:
    'No internet connection found. Please check your connection or try again.',
  Timeout: 'Request timed out. Please try again.',
  UserPassIncorrect: 'The username or password is incorrect.',
  NotFound: '404: Not found.',
  CampaignCodeInvalid: 'Sorry, this code appears to be invalid.',
  DepartureDateTooLow:
    'Due to a time zone difference, your departure date must be greater than today.',

  // TODO: This is wrong and will never work
  ResidentIdentifierInvalid: `Purchase failed - Please check your input for {{ residentIdentifierName$ | async }} in traveller's details.`,

  // status 422 with duplicatePurchase code
  DuplicatePurchase:
    'It looks like you have already bought a policy for this trip. Please check your emails or contact us.',

  // status 410 - when quote is already bought
  AlreadyPurchased:
    'It looks like you have already bought a policy for this trip.',

  // code for 3ds scenario- not used on ui.
  PaymentRequiredError: '',
};
